<template>
  <div class="row">
    <div class="col-md-6">
      <div class="card card-table">
        <div class="card-header">{{ $t("modal.export") }}</div>
        <div class="card-body mb-3">
          <button
            class="btn btn-primary mx-2 my-1"
            type="button"
            @click="getFoods"
          >
            {{ $t("button.food") }}
          </button>
          <button
            v-if="inventoryMachineType == 1"
            class="btn btn-primary mx-2 my-1"
            type="button"
            @click="getSuppliers"
          >
            {{ $t("button.supplier") }}
          </button>
          <button
            v-if="inventoryMachineType == 1"
            class="btn btn-primary mx-2 my-1"
            type="button"
            @click="getWarehouses"
          >
            {{ $t("button.warehouse") }}
          </button>
        </div>
      </div>
    </div>
    <div
      class="col-md-6"
      v-if="inventoryMachineType == 1 || inventoryMachineType == 3"
    >
      <div class="card card-table">
        <div class="card-header">{{ $t("modal.import") }}</div>
        <div class="card-body mb-3">
          <import-part
            class="mx-2 my-1"
            @onImport="postTrade"
            importModalId="importInventory"
            :title="`${$t('modal.importinventory')}`"
            :btnName="`${$t('button.inventorylist')}`"
          />
          <import-part
            class="mx-2 my-1"
            v-if="inventoryMachineType == 3"
            @onImport="postCasioPurchaseOrders"
            importModalId="importPurchaseOrders"
            title="匯入採購單"
            btnName="採購單"
          />
          <import-part
            class="mx-2 my-1"
            v-if="inventoryMachineType == 3"
            @onImport="postCasioPurchases"
            importModalId="importPurchases"
            title="匯入進貨單"
            btnName="進貨單"
          />
          <import-part
            class="mx-2 my-1"
            v-if="inventoryMachineType == 3"
            @onImport="postCasioPurchaseReturns"
            importModalId="importPurchaseReturns"
            title="匯入進退單"
            btnName="進退單"
          />
          <import-part
            class="mx-2 my-1"
            v-if="inventoryMachineType == 3"
            @onImport="postCasioStockTransfers"
            importModalId="importStockTransfers"
            title="匯入調撥單"
            btnName="調撥單"
          />
        </div>
      </div>
    </div>
    <warehouse-select
      :trigger="warehouseTrigger"
      @onSaved="onWarehouseSelect"
    ></warehouse-select>
  </div>
</template>

<script>
import importPart from "@/components/ImportPart";
import warehouseSelect from "@/components/selects/WarehouseSelects";

export default {
  data() {
    return {
      warehouseTrigger: false,
      warehouse: {},
    };
  },
  components: {
    importPart,
    warehouseSelect,
  },
  computed: {
    inventoryMachineType() {
      return this.$store.state.inventoryMachineType;
    },
  },
  methods: {
    onWarehouseSelect(item) {
      this.warehouse = item;
      if (!this.warehouse) {
        this.$func.message.alert("請選擇倉庫");
        return;
      }
      if (this.inventoryMachineType == 1) {
        this.$api.foods.getCasio(this.warehouse.WarehouseId);
      } else {
        this.$api.foods.getTYSSO(this.warehouse.WarehouseId);
      }
    },
    getFoods() {
      this.warehouseTrigger = !this.warehouseTrigger;
    },
    getSuppliers() {
      this.$api.suppliers.getCasio();
    },
    getWarehouses() {
      this.$api.warehouses.getCasio();
    },
    postTrade(file) {
      let formData = new FormData();
      formData.append("file", file);
      this.$api.inventorys.postCasio(formData);
    },
    postCasioPurchaseOrders(file) {
      let formData = new FormData();
      formData.append("file", file);
      this.$api.inventorys.postCasioPurchaseOrders(formData);
    },
    postCasioPurchases(file) {
      let formData = new FormData();
      formData.append("file", file);
      this.$api.inventorys.postCasioPurchases(formData);
    },
    postCasioPurchaseReturns(file) {
      let formData = new FormData();
      formData.append("file", file);
      this.$api.inventorys.postCasioPurchaseReturns(formData);
    },
    postCasioStockTransfers(file) {
      let formData = new FormData();
      formData.append("file", file);
      this.$api.inventorys.postCasioStockTransfers(formData);
    },
  },
};
</script>
